import { cookies } from './cookies'

export const saveRedirectURL = (token) => {
  cookies.set('redirectURL', token, {
    path: '/',
    maxAge: 60 * 60,
    domain:
      window.location.host.indexOf('www') > -1
        ? window.location.host.replace('www', '')
        : null,
  })
  return Promise.resolve()
}

export const getRedirectURL = () => {
  return cookies.get('redirectURL')
}
